import { Instant, InstantSchema } from "@/Temporal"
import { objectSchema } from "vue-utils"
import type { Id } from "."

export interface UserTimeStamp {
	userId: Id
	timeStamp: Instant
}

export const UserTimeStamp = objectSchema<UserTimeStamp>({
	userId: Number,
	timeStamp: InstantSchema,
})
